import { getImage, getSrc } from './media';

export function formatResource(item: any, type: string, translations: any) {
    switch (type) {
        case 'ebook':
        case 'DatoCmsEbook':
            return formatEbook(item, translations);
        case 'DatoCmsEvent':
        case 'event':
            return formatEvent(item, translations);
        case 'DatoCmsMethodology':
        case 'methodology':
            return formatMethodology(item, translations);
        case 'DatoCmsPodcast':
        case 'podcast':
            return formatPodcast(item, translations);
        case 'DatoCmsWebinar':
        case 'webinar':
            return formatWebinar(item, translations);
        case 'DatoCmsSuccessStory':
        case 'successStory':
            return formatSuccessStory(item, translations);
        case 'DatoCmsBlogPost':
        case 'DatoCmsGlossaryTerm':
        case 'DatoCmsPage':
        case 'article':
            return formatArticle(item, translations);

        default:
            return item;
    }
}

function formatArticle(item: any, translations: any) {
    const href = item?.href ?? item?.slug;

    return {
        ...item,
        href,
        media: getImage(item?.media),
        cta: {
            label: translations['cta.label.viewmore'].text,
            href,
        },
    };
}

function formatSuccessStory(item: any, translations: any) {
    return {
        ...item,
        media: getImage(item?.image),
        logo: item?.image
            ? {
                  src: getSrc(item.image),
                  alt: item?.image?.alt ?? item?.title,
                  ...item?.image,
              }
            : undefined,
        cta: item?.href
            ? {
                  label: translations['cta.label.viewmore'].text,
                  href: item.href,
                  target: '_blank',
                  rel: 'noopener noreferrer',
              }
            : null,
    };
}

function formatWebinar(item: any, translations: any) {
    return {
        ...item,
        media: getImage(item.image),
        mediaWithFrame: true,
        persons: item?.speakers?.map((speaker: any) => ({
            name: speaker?.name,
            image: getImage(speaker?.image),
        })),
        cta: item?.href
            ? {
                  label: translations['cta.label.viewmore'].text,
                  href: item.href,
                  target: '_blank',
              }
            : null,
    };
}

function formatPodcast(item: any, translations: any) {
    return {
        ...item,
        cardType: 'podcast',
        platforms: [
            item?.spotifyUrl && {
                name: 'Spotify',
                url: item?.spotifyUrl,
                icon: 'spotify',
            },
            item?.appleUrl && {
                name: 'Apple Podcasts',
                url: item?.appleUrl,
                icon: 'apple-podcast',
            },
            item?.ivooxUrl && {
                name: 'iVoox',
                url: item?.ivooxUrl,
                icon: 'ivoox',
            },
        ].filter(Boolean),
    };
}

function formatMethodology(item: any, translations: any) {
    return {
        ...item,
        cta: item?.href
            ? {
                  label: translations['cta.label.viewmore'].text,
                  href: item.href,
                  target: '_blank',
              }
            : null,
        media: getImage(item.image),
    };
}

function formatEvent(item: any, translations: any) {
    return {
        ...item,
        cta: item?.href
            ? {
                  label: translations['cta.label.viewmore'].text,
                  href: item?.href,
                  target: '_blank',
                  rel: 'noopener noreferrer',
              }
            : null,
        media: getImage(item.media),
    };
}

function formatEbook(item: any, translations: any) {
    return {
        ...item,
        cta: {
            label: translations['cta.label.viewmore'].text,
            href: item?.href,
            target: '_blank',
        },
        media: getImage(item.image),
        mediaWithFrame: true,
    };
}
